/* eslint-disable camelcase */
import * as Yup from 'yup';

export const ChimeSchema = {
  Create: Yup.object().shape({
    amazon_user_id: Yup.string().optional(),
    platform_login_id: Yup.string().required(),
  }),
  Update: Yup.object().shape({
    amazon_user_id: Yup.string().optional(),
  }),
  NONE: Yup.object().shape({}),
};
